/** Case-, accent- and whitespace-insensitive, so "Naleśniki " matches "nalesniki". */
export const normalizeProductName = (name: string): string =>
  name
    .replace(/ł/g, 'l')
    .replace(/Ł/g, 'L')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
